import type { EntitlementsState } from '../common/redux/features/entitlements/entitlementsSlice'
import type { EntitlementsContext } from '../common/redux/api/web-api'

export const EntitlementsEnum = {
    BYPASS_ENTITLEMENTS: 1 << 0,
    AUTOMATED_REPORTS: 1 << 1,
    REPORTS_EXTENDED_HISTORY: 1 << 2,
    STATISTICS_EXTENDED_HISTORY: 1 << 3,
    OCPP_RELAY: 1 << 4,
    CHARGER_GROUPS: 1 << 5,
    EAPI_EXTENDED_USE: 1 << 6,
    CALLBACKS_EXTENDED_USE: 1 << 7,
    LOAD_MANAGEMENT_SCHEDULE: 1 << 8,
    PRIORITIZED_CHARGING: 1 << 9,
    HIERARCHICAL_LOAD_MANAGEMENT: 1 << 10,
}

export const REPORT_HISTORY_RESTRICTION_DAYS = 45

type EntitlementsLike = Partial<EntitlementsState> | Partial<EntitlementsContext> | null | undefined

const hasEntitlement = (mask: number, flag: number) => (mask & flag) !== 0

const getEntitlementsBitmask = (entitlements?: EntitlementsLike): number => Number(entitlements?.entitlementsMask ?? 0)

const bypassesEntitlementEnforcement = (entitlements?: EntitlementsLike): boolean =>
    Boolean(entitlements?.bypassEntitlementEnforcement) ||
    hasEntitlement(getEntitlementsBitmask(entitlements), EntitlementsEnum.BYPASS_ENTITLEMENTS)

export const hasAccessToEntitlement = (entitlement: number, entitlements?: EntitlementsLike) => {
    if (bypassesEntitlementEnforcement(entitlements)) return true

    return hasEntitlement(getEntitlementsBitmask(entitlements), entitlement)
}

export const canAccessBillingPage = (entitlements?: EntitlementsLike) =>
    !hasAccessToEntitlement(EntitlementsEnum.BYPASS_ENTITLEMENTS, entitlements)
